import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { PageMetaData } from "../../Layout/PageMetaData";
import { StandardLayout } from "../../Layout/StandardLayout";
import { StandardLayoutHeaderWithPortal } from "../../Layout/StandardLayoutV2/StandardLayoutHeader/StandardLayoutHeaderWithPortal";
import { SpaceHeaderTitleText } from "../../Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";
import { RIGHT_OPTIONS_WIDTH } from "../Header/RightOptions";
import { TabNavigation } from "../shared/TabNavigation";
import { Recommendations } from "./Recommendations";

const i18nBase = "connections";

export const Connections = () => (
  <>
    <StandardLayoutHeaderWithPortal
      leftContent={
        <div className="flex flex-row items-center gap-6">
          <SpaceHeaderTitleText>{t(`${i18nBase}.title`)}</SpaceHeaderTitleText>
          <TabNavigation className="m-auto" />
        </div>
      }
      rightContent={<div className={RIGHT_OPTIONS_WIDTH} />}
    />
    <StandardLayout.Body hasPaddingTopMobile={false}>
      <PageMetaData title={t(`${i18nBase}.title`)} />

      <StandardLayout.Content className={classNames("md:!min-w-0")}>
        <div>{t(`${i18nBase}.my_connections`)}</div>
        <div>{t(`${i18nBase}.requests`)}</div>
        <Recommendations />
      </StandardLayout.Content>
    </StandardLayout.Body>
  </>
);
